import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import Grid from '@mui/material/Grid2';
import GeneralCaseDisccuss from './GeneralCaseDisccuss';
import TaskAllDisccussCase from '../BasicCaseTabs/TaskAllDisccussCase';

function DiscussTaskCase({showCase, casediscuss}) {

    const [activeTabCase, setActiveTabCase] = useState("taskdiscuss");
  return (
    <Grid size={{sm:12}} container className="tab_controllers control_splits" alignContent="flex-start">
        <Tabs
            activeKey={activeTabCase}
            onSelect={(key) => setActiveTabCase(key)}
            defaultActiveKey="taskdiscuss"
            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
        >
            <Tab eventKey="taskdiscuss" title="Task Discussion">
                {activeTabCase === "taskdiscuss" && <GeneralCaseDisccuss casediscuss={casediscuss}/>}
            </Tab>
            {showCase && 
            <Tab eventKey="casediscuss" title="Case Discussion">
                {activeTabCase === "casediscuss" && <TaskAllDisccussCase casediscuss={casediscuss}/>}
            </Tab>
            }
        </Tabs>
    </Grid>
  )
}

export default DiscussTaskCase
